"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Breadcrumb = _ref => {
  let {
    href,
    children
  } = _ref;
  if (_lodash.default.isUndefined(href)) {
    return /*#__PURE__*/_react.default.createElement(_material.Typography, {
      color: "text.primary"
    }, children);
  }
  return /*#__PURE__*/_react.default.createElement(_material.Link, {
    color: "inherit",
    href: href,
    sx: {
      textDecoration: 'transparent',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  }, children);
};
var _default = exports.default = Breadcrumb;